/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { AggregationMetadata } from "../models/aggregationMetadata";

import type { AggregationMetadataRequest } from "../models/aggregationMetadataRequest";

import type { AggregationQuery } from "../models/aggregationQuery";

import type { AggregationResponse } from "../models/aggregationResponse";

import type { BatchQueryAggregationMetadataRequest } from "../models/batchQueryAggregationMetadataRequest";

import type { BatchQueryAggregationQuery } from "../models/batchQueryAggregationQuery";

import type { BatchResponseAggregationMetadata } from "../models/batchResponseAggregationMetadata";

import type { BatchResponseAggregationResponse } from "../models/batchResponseAggregationResponse";

import type { NamedBatchQueryAggregationQuery } from "../models/namedBatchQueryAggregationQuery";

import type { NamedBatchResponseAggregationResponse } from "../models/namedBatchResponseAggregationResponse";

import type { SourceEnvAggregateMetadataParams } from "../models/sourceEnvAggregateMetadataParams";

import type { SourceEnvAggregateParams } from "../models/sourceEnvAggregateParams";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Aggregate
 */
export const aggregate = (
  aggregationQuery: AggregationQuery,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<AggregationResponse>(
    {
      url: `/api/aggregation`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: aggregationQuery,
      signal,
    },
    options,
  );
};

export const getAggregateInfiniteQueryKey = (
  aggregationQuery?: AggregationQuery,
) => {
  return ["infinite", `/api/aggregation`, aggregationQuery] as const;
};

export const getAggregateQueryKey = (aggregationQuery?: AggregationQuery) => {
  return [`/api/aggregation`, aggregationQuery] as const;
};

export const getAggregateInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof aggregate>>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof aggregate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAggregateInfiniteQueryKey(aggregationQuery);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof aggregate>>> = ({
    signal,
    meta,
  }) => aggregate(aggregationQuery, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof aggregate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AggregateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof aggregate>>
>;
export type AggregateInfiniteQueryError = ErrorType<unknown>;

export function useAggregateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof aggregate>>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof aggregate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregate>>,
          TError,
          Awaited<ReturnType<typeof aggregate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof aggregate>>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof aggregate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregate>>,
          TError,
          Awaited<ReturnType<typeof aggregate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof aggregate>>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof aggregate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Aggregate
 */

export function useAggregateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof aggregate>>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof aggregate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAggregateInfiniteQueryOptions(
    aggregationQuery,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Aggregate
 */
export const prefetchAggregateInfinite = async <
  TData = Awaited<ReturnType<typeof aggregate>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof aggregate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getAggregateInfiniteQueryOptions(
    aggregationQuery,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getAggregateQueryOptions = <
  TData = Awaited<ReturnType<typeof aggregate>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregate>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAggregateQueryKey(aggregationQuery);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof aggregate>>> = ({
    signal,
    meta,
  }) => aggregate(aggregationQuery, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof aggregate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AggregateQueryResult = NonNullable<
  Awaited<ReturnType<typeof aggregate>>
>;
export type AggregateQueryError = ErrorType<unknown>;

export function useAggregate<
  TData = Awaited<ReturnType<typeof aggregate>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregate>>,
          TError,
          Awaited<ReturnType<typeof aggregate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregate<
  TData = Awaited<ReturnType<typeof aggregate>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregate>>,
          TError,
          Awaited<ReturnType<typeof aggregate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregate<
  TData = Awaited<ReturnType<typeof aggregate>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregate>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Aggregate
 */

export function useAggregate<
  TData = Awaited<ReturnType<typeof aggregate>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregate>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAggregateQueryOptions(aggregationQuery, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Aggregate
 */
export const prefetchAggregate = async <
  TData = Awaited<ReturnType<typeof aggregate>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregate>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getAggregateQueryOptions(aggregationQuery, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Batch Aggregate
 */
export const batchAggregate = (
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<BatchResponseAggregationResponse>(
    {
      url: `/api/aggregation/batch`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: batchQueryAggregationQuery,
      signal,
    },
    options,
  );
};

export const getBatchAggregateInfiniteQueryKey = (
  batchQueryAggregationQuery?: BatchQueryAggregationQuery,
) => {
  return [
    "infinite",
    `/api/aggregation/batch`,
    batchQueryAggregationQuery,
  ] as const;
};

export const getBatchAggregateQueryKey = (
  batchQueryAggregationQuery?: BatchQueryAggregationQuery,
) => {
  return [`/api/aggregation/batch`, batchQueryAggregationQuery] as const;
};

export const getBatchAggregateInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof batchAggregate>>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof batchAggregate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBatchAggregateInfiniteQueryKey(batchQueryAggregationQuery);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchAggregate>>> = ({
    signal,
    meta,
  }) =>
    batchAggregate(
      batchQueryAggregationQuery,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof batchAggregate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BatchAggregateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchAggregate>>
>;
export type BatchAggregateInfiniteQueryError = ErrorType<unknown>;

export function useBatchAggregateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof batchAggregate>>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof batchAggregate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchAggregate>>,
          TError,
          Awaited<ReturnType<typeof batchAggregate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBatchAggregateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof batchAggregate>>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof batchAggregate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchAggregate>>,
          TError,
          Awaited<ReturnType<typeof batchAggregate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBatchAggregateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof batchAggregate>>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof batchAggregate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Batch Aggregate
 */

export function useBatchAggregateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof batchAggregate>>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof batchAggregate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBatchAggregateInfiniteQueryOptions(
    batchQueryAggregationQuery,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Batch Aggregate
 */
export const prefetchBatchAggregateInfinite = async <
  TData = Awaited<ReturnType<typeof batchAggregate>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof batchAggregate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getBatchAggregateInfiniteQueryOptions(
    batchQueryAggregationQuery,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getBatchAggregateQueryOptions = <
  TData = Awaited<ReturnType<typeof batchAggregate>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof batchAggregate>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBatchAggregateQueryKey(batchQueryAggregationQuery);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchAggregate>>> = ({
    signal,
    meta,
  }) =>
    batchAggregate(
      batchQueryAggregationQuery,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof batchAggregate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BatchAggregateQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchAggregate>>
>;
export type BatchAggregateQueryError = ErrorType<unknown>;

export function useBatchAggregate<
  TData = Awaited<ReturnType<typeof batchAggregate>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof batchAggregate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchAggregate>>,
          TError,
          Awaited<ReturnType<typeof batchAggregate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBatchAggregate<
  TData = Awaited<ReturnType<typeof batchAggregate>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof batchAggregate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchAggregate>>,
          TError,
          Awaited<ReturnType<typeof batchAggregate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBatchAggregate<
  TData = Awaited<ReturnType<typeof batchAggregate>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof batchAggregate>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Batch Aggregate
 */

export function useBatchAggregate<
  TData = Awaited<ReturnType<typeof batchAggregate>>,
  TError = ErrorType<unknown>,
>(
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof batchAggregate>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBatchAggregateQueryOptions(
    batchQueryAggregationQuery,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Batch Aggregate
 */
export const prefetchBatchAggregate = async <
  TData = Awaited<ReturnType<typeof batchAggregate>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  batchQueryAggregationQuery: BatchQueryAggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof batchAggregate>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getBatchAggregateQueryOptions(
    batchQueryAggregationQuery,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Batch Aggregate Metadata
 */
export const batchAggregateMetadata = (
  batchQueryAggregationMetadataRequest: BatchQueryAggregationMetadataRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<BatchResponseAggregationMetadata>(
    {
      url: `/api/aggregation/batch/metadata`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: batchQueryAggregationMetadataRequest,
      signal,
    },
    options,
  );
};

export const getBatchAggregateMetadataMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchAggregateMetadata>>,
    TError,
    { data: BatchQueryAggregationMetadataRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchAggregateMetadata>>,
  TError,
  { data: BatchQueryAggregationMetadataRequest },
  TContext
> => {
  const mutationKey = ["batchAggregateMetadata"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchAggregateMetadata>>,
    { data: BatchQueryAggregationMetadataRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return batchAggregateMetadata(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchAggregateMetadataMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchAggregateMetadata>>
>;
export type BatchAggregateMetadataMutationBody =
  BatchQueryAggregationMetadataRequest;
export type BatchAggregateMetadataMutationError = ErrorType<unknown>;

/**
 * @summary Batch Aggregate Metadata
 */
export const useBatchAggregateMetadata = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchAggregateMetadata>>,
      TError,
      { data: BatchQueryAggregationMetadataRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchAggregateMetadata>>,
  TError,
  { data: BatchQueryAggregationMetadataRequest },
  TContext
> => {
  const mutationOptions = getBatchAggregateMetadataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Batch Aggregate With Name
 */
export const batchAggregateWithName = (
  namedBatchQueryAggregationQuery: NamedBatchQueryAggregationQuery,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NamedBatchResponseAggregationResponse>(
    {
      url: `/api/aggregation/bulk`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: namedBatchQueryAggregationQuery,
      signal,
    },
    options,
  );
};

export const getBatchAggregateWithNameMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchAggregateWithName>>,
    TError,
    { data: NamedBatchQueryAggregationQuery },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchAggregateWithName>>,
  TError,
  { data: NamedBatchQueryAggregationQuery },
  TContext
> => {
  const mutationKey = ["batchAggregateWithName"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchAggregateWithName>>,
    { data: NamedBatchQueryAggregationQuery }
  > = (props, context) => {
    const { data } = props ?? {};

    return batchAggregateWithName(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchAggregateWithNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchAggregateWithName>>
>;
export type BatchAggregateWithNameMutationBody =
  NamedBatchQueryAggregationQuery;
export type BatchAggregateWithNameMutationError = ErrorType<unknown>;

/**
 * @summary Batch Aggregate With Name
 */
export const useBatchAggregateWithName = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchAggregateWithName>>,
      TError,
      { data: NamedBatchQueryAggregationQuery },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchAggregateWithName>>,
  TError,
  { data: NamedBatchQueryAggregationQuery },
  TContext
> => {
  const mutationOptions = getBatchAggregateWithNameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Count
 */
export const count = (
  aggregationQuery: AggregationQuery,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<number>(
    {
      url: `/api/aggregation/count`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: aggregationQuery,
      signal,
    },
    options,
  );
};

export const getCountQueryKey = (aggregationQuery?: AggregationQuery) => {
  return [`/api/aggregation/count`, aggregationQuery] as const;
};

export const getCountQueryOptions = <
  TData = Awaited<ReturnType<typeof count>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof count>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountQueryKey(aggregationQuery);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof count>>> = ({
    signal,
    meta,
  }) => count(aggregationQuery, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof count>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountQueryResult = NonNullable<Awaited<ReturnType<typeof count>>>;
export type CountQueryError = ErrorType<unknown>;

export function useCount<
  TData = Awaited<ReturnType<typeof count>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof count>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof count>>,
          TError,
          Awaited<ReturnType<typeof count>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCount<
  TData = Awaited<ReturnType<typeof count>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof count>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof count>>,
          TError,
          Awaited<ReturnType<typeof count>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCount<
  TData = Awaited<ReturnType<typeof count>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof count>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Count
 */

export function useCount<
  TData = Awaited<ReturnType<typeof count>>,
  TError = ErrorType<unknown>,
>(
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof count>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCountQueryOptions(aggregationQuery, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Count
 */
export const prefetchCount = async <
  TData = Awaited<ReturnType<typeof count>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  aggregationQuery: AggregationQuery,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof count>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getCountQueryOptions(aggregationQuery, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Aggregate Groups
 */
export const aggregateGroups = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<string[]>(
    { url: `/api/aggregation/groups`, method: "GET", signal },
    options,
  );
};

export const getAggregateGroupsQueryKey = () => {
  return [`/api/aggregation/groups`] as const;
};

export const getAggregateGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof aggregateGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof aggregateGroups>>, TError, TData>
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAggregateGroupsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof aggregateGroups>>> = ({
    signal,
    meta,
  }) => aggregateGroups({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof aggregateGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AggregateGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof aggregateGroups>>
>;
export type AggregateGroupsQueryError = ErrorType<unknown>;

export function useAggregateGroups<
  TData = Awaited<ReturnType<typeof aggregateGroups>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregateGroups>>,
          TError,
          Awaited<ReturnType<typeof aggregateGroups>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregateGroups<
  TData = Awaited<ReturnType<typeof aggregateGroups>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregateGroups>>,
          TError,
          Awaited<ReturnType<typeof aggregateGroups>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregateGroups<
  TData = Awaited<ReturnType<typeof aggregateGroups>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Aggregate Groups
 */

export function useAggregateGroups<
  TData = Awaited<ReturnType<typeof aggregateGroups>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAggregateGroupsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Aggregate Groups
 */
export const prefetchAggregateGroups = async <
  TData = Awaited<ReturnType<typeof aggregateGroups>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getAggregateGroupsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Aggregate Metadata
 */
export const aggregateMetadata = (
  aggregationMetadataRequest: AggregationMetadataRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<AggregationMetadata>(
    {
      url: `/api/aggregation/metadata`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: aggregationMetadataRequest,
      signal,
    },
    options,
  );
};

export const getAggregateMetadataQueryKey = (
  aggregationMetadataRequest?: AggregationMetadataRequest,
) => {
  return [`/api/aggregation/metadata`, aggregationMetadataRequest] as const;
};

export const getAggregateMetadataQueryOptions = <
  TData = Awaited<ReturnType<typeof aggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAggregateMetadataQueryKey(aggregationMetadataRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof aggregateMetadata>>
  > = ({ signal, meta }) =>
    aggregateMetadata(
      aggregationMetadataRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof aggregateMetadata>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AggregateMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof aggregateMetadata>>
>;
export type AggregateMetadataQueryError = ErrorType<unknown>;

export function useAggregateMetadata<
  TData = Awaited<ReturnType<typeof aggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregateMetadata>>,
          TError,
          Awaited<ReturnType<typeof aggregateMetadata>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregateMetadata<
  TData = Awaited<ReturnType<typeof aggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregateMetadata>>,
          TError,
          Awaited<ReturnType<typeof aggregateMetadata>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregateMetadata<
  TData = Awaited<ReturnType<typeof aggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Aggregate Metadata
 */

export function useAggregateMetadata<
  TData = Awaited<ReturnType<typeof aggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAggregateMetadataQueryOptions(
    aggregationMetadataRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Aggregate Metadata
 */
export const prefetchAggregateMetadata = async <
  TData = Awaited<ReturnType<typeof aggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  aggregationMetadataRequest: AggregationMetadataRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof aggregateMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getAggregateMetadataQueryOptions(
    aggregationMetadataRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Source Env Aggregate
 */
export const sourceEnvAggregate = (
  aggregationQuery: AggregationQuery,
  params?: SourceEnvAggregateParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<AggregationResponse>(
    {
      url: `/api/aggregation/source-env`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: aggregationQuery,
      params,
      signal,
    },
    options,
  );
};

export const getSourceEnvAggregateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sourceEnvAggregate>>,
    TError,
    { data: AggregationQuery; params?: SourceEnvAggregateParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sourceEnvAggregate>>,
  TError,
  { data: AggregationQuery; params?: SourceEnvAggregateParams },
  TContext
> => {
  const mutationKey = ["sourceEnvAggregate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sourceEnvAggregate>>,
    { data: AggregationQuery; params?: SourceEnvAggregateParams }
  > = (props, context) => {
    const { data, params } = props ?? {};

    return sourceEnvAggregate(data, params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type SourceEnvAggregateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sourceEnvAggregate>>
>;
export type SourceEnvAggregateMutationBody = AggregationQuery;
export type SourceEnvAggregateMutationError = ErrorType<unknown>;

/**
 * @summary Source Env Aggregate
 */
export const useSourceEnvAggregate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sourceEnvAggregate>>,
      TError,
      { data: AggregationQuery; params?: SourceEnvAggregateParams },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sourceEnvAggregate>>,
  TError,
  { data: AggregationQuery; params?: SourceEnvAggregateParams },
  TContext
> => {
  const mutationOptions = getSourceEnvAggregateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Source Env Aggregate Metadata
 */
export const sourceEnvAggregateMetadata = (
  aggregationMetadataRequest: AggregationMetadataRequest,
  params?: SourceEnvAggregateMetadataParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<AggregationMetadata>(
    {
      url: `/api/aggregation/source-env/metadata`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: aggregationMetadataRequest,
      params,
      signal,
    },
    options,
  );
};

export const getSourceEnvAggregateMetadataQueryKey = (
  aggregationMetadataRequest?: AggregationMetadataRequest,
  params?: SourceEnvAggregateMetadataParams,
) => {
  return [
    `/api/aggregation/source-env/metadata`,
    ...(params ? [params] : []),
    aggregationMetadataRequest,
  ] as const;
};

export const getSourceEnvAggregateMetadataQueryOptions = <
  TData = Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  params?: SourceEnvAggregateMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSourceEnvAggregateMetadataQueryKey(aggregationMetadataRequest, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>
  > = ({ signal, meta }) =>
    sourceEnvAggregateMetadata(
      aggregationMetadataRequest,
      params,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SourceEnvAggregateMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>
>;
export type SourceEnvAggregateMetadataQueryError = ErrorType<unknown>;

export function useSourceEnvAggregateMetadata<
  TData = Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  params: undefined | SourceEnvAggregateMetadataParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
          TError,
          Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSourceEnvAggregateMetadata<
  TData = Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  params?: SourceEnvAggregateMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
          TError,
          Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSourceEnvAggregateMetadata<
  TData = Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  params?: SourceEnvAggregateMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Source Env Aggregate Metadata
 */

export function useSourceEnvAggregateMetadata<
  TData = Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  aggregationMetadataRequest: AggregationMetadataRequest,
  params?: SourceEnvAggregateMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSourceEnvAggregateMetadataQueryOptions(
    aggregationMetadataRequest,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Source Env Aggregate Metadata
 */
export const prefetchSourceEnvAggregateMetadata = async <
  TData = Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  aggregationMetadataRequest: AggregationMetadataRequest,
  params?: SourceEnvAggregateMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvAggregateMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSourceEnvAggregateMetadataQueryOptions(
    aggregationMetadataRequest,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
